/**
 * Route for `pinterest-conversions-api`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { PinterestConversionsApiPage } from "../features/pinterest-conversions-api/PinterestConversionsApiPage";

export const pinterestConversionsApiRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/pinterest-conversions-api",
	component: PinterestConversionsApiPage,
});

export default pinterestConversionsApiRoute;
